module.exports = __webpack_public_path__ + "static/img/icon_confirm.f2888469.svg";